module.exports = __webpack_public_path__ + "img/arrow_right_2.f977b1e5.svg";